import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SnackBarAlertContext } from "../../../contexts/SnackbarContext";
import request from "../../../request";
import { SidebarContext } from "../../../contexts/SidebarContext";

const useLazyQuery = (
  endPoint: string,
  variables?: any,
  reDirectTo?: string | null,
  hasPayloadDependency?: boolean
) => {
  const navigate = useNavigate();
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const { payload, setPayload } = useContext(SidebarContext);

  const [initialMount, setInitialMount] = useState<boolean>(true);
  const [response, setResponse] = useState<{
    loading: boolean;
    error: any;
    data: any;
  }>({
    loading: false,
    error: null,
    data: null,
  });
  const fetchData = async () => {
    if (initialMount) {
      if (
        hasPayloadDependency === true &&
        (payload.skip !== 0 ||
          payload.take !== 25 ||
          payload.sortBy !== null ||
          payload.sortOrder !== null ||
          (payload?.filter?.default ?? null) !== null ||
          payload.search)
      ) {
        // Reset payload on initial mount
        setInitialMount(false);
        setPayload((prevData: any) => {
          return {
            ...prevData,
            skip: 0,
            take: 25,
            sortOrder: null,
            sortBy: null,
            search: "",
            filter: { ...prevData?.filter, default: null },
          };
        });
        if (hasPayloadDependency === true) return;
      } else {
        setInitialMount(false);
      }
    }
    try {
      setResponse({
        loading: true,
        data: null,
        error: null,
      });
      let apiResponse = await request.get(endPoint, variables);
      if (response) {
        setResponse({
          loading: false,
          data: apiResponse?.data,
          error: null,
        });
        return apiResponse;
      }
    } catch (error: any) {
      setResponse({ loading: false, data: null, error: error });
      if (reDirectTo) {
        navigate(reDirectTo);
      }
      snackBarAlertContext.set({
        status: true,
        type: "error",
        message: error.message,
      });
    }
  };

  return { ...response, fetchData };
};

export default useLazyQuery;
